export enum SaveOption {
    Save = "Save",
    SaveMatch = "SaveMatch",
    SaveMatchPostNew = "SaveMatchPostNew",
    SaveMatchAutoMerge = "SaveMatchAutoMerge",
    SavePost = "SavePost"
}